import { FC, useEffect, useState } from 'react';
import StudentName from '../Name';
import {
  IGetStudentTestInfo,
  IGetStudentTestInfoOcean,
  IStudent,
} from '../../../../models/students.model';
import Radio from '../../../Radio';
import StudentCbtTable from './StudentCbtTable';
import StudentOceanTable from './StudentOceanTable';
import useAxios from '../../../../hooks/useAxios';
import {
  getStudentTestInfo,
  getStudentTestOceanInfo,
} from '../../../../api/students.api';
import Loader from '../../../Loader';
import ErrorResponse from '../../../ErrorResponse';

enum Contents {
  Cbt,
  Ocean,
  Prediger,
};

interface IProps {
  student?: IStudent;
};

const StudentTest: FC<IProps> = ({
  student,
}) => {
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetStudentTestInfo>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetStudentTestInfoOcean>();

  const [content, setContent] = useState<Contents>(Contents.Cbt);

  useEffect(() => {
    if (student?.studentCode) {
      execute(getStudentTestInfo(student.studentCode));
      execute2(getStudentTestOceanInfo(student.studentCode));
    }
  }, [student]);

  const checked = (value: Contents) => content === value;

  const renderContents = () => {
    switch (content) {
      case Contents.Cbt:
        return (
          <StudentCbtTable
            data={res?.data}
          />
        );
      case Contents.Ocean:
      case Contents.Prediger:
        return (
          <StudentOceanTable
            data={res2?.data?.filter(item => item.eduStepCode === (content === Contents.Ocean ? 'EM' : 'MD'))}
            eduStepCode={(content === Contents.Ocean ? 'EM' : 'MD')}
          />
        );
    }
  };

  return (
    <>
      {(isLoading || isLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <StudentName student={student} />
    
      <div className="comm-bx__space">
        <div className='radio-area justify-content-end'>
          <Radio
            checked={checked(Contents.Cbt)}
            onChange={() => setContent(Contents.Cbt)}
            text="CBT"
          />
          <Radio
            className="ml-1"
            checked={checked(Contents.Ocean)}
            onChange={() => setContent(Contents.Ocean)}
            text="OCEAN"
          />
          <Radio
            className="ml-1"
            checked={checked(Contents.Prediger)}
            onChange={() => setContent(Contents.Prediger)}
            text="Prediger"
          />
        </div>
      </div>
      {renderContents()}
    </>
  );
};

export default StudentTest;
